import { Facebook, Instagram, Phone, Telegram, Viber, WhatsApp } from "../Assets/Icons";
import { Restaurant, Cafe, Pizza, Hotel, FastFood, CoffeeCup, Delivery, About } from "../Assets/Images";
import { BusinessTypes, CurrencyTypes, CustomerCount, IAutocompleteData, IBusinessUITemplate, IProfilecontactItem, NavItem, WeekDays, } from "../Interfaces/componentTypes";
import { t } from 'i18next'
export const mainNavs: NavItem = [

    {
        title: 'Restaurants',
        href: '/restaurants',
        icon: Restaurant
    },
    {
        title: 'Cafes',
        href: '/cafes',
        icon: Cafe
    },
    {
        title: 'Delivery',
        href: '/delivery',
        icon: Delivery
    },
    {
        title: 'About Us',
        href: '/about',
        icon: About
    },

];


export const customersCount: IAutocompleteData = [
    {
        id: CustomerCount.SMALL,
        title: '0-100'
    },
    {
        id: CustomerCount.MEDIUM,
        title: '100-500'
    },
    {
        id: CustomerCount.BIG,
        title: '500-5000'
    },
    {
        id: CustomerCount.LARGE,
        title: '5000 +'
    }
];

export const weekDays : IAutocompleteData = [
    {
        id:WeekDays.MONDAY,
        title:t('Directories.Week_Days.Monday')
    },
    {
        id:WeekDays.TUESDAY,
        title:t('Directories.Week_Days.Tuesday')
    },
    {
        id:WeekDays.WEDNESDAY,
        title:t('Directories.Week_Days.Wednesday')
    },
    {
        id:WeekDays.THURSDAY,
        title:t('Directories.Week_Days.Thursday')
    },
    {
        id:WeekDays.FRIDAY,
        title:t('Directories.Week_Days.Friday')
    },
    {
        id:WeekDays.SATURDAY,
        title:t('Directories.Week_Days.Saturday')
    },
    {
        id:WeekDays.SUNDAY,
        title:t('Directories.Week_Days.Sunday')
    }
];

export const BUSINESS_TYPE_ICONS = {
    [BusinessTypes.CAFE]: Cafe,
    [BusinessTypes.SHOP]: Cafe,
    [BusinessTypes.RESTAURANT]: Restaurant,
    [BusinessTypes.PIZZERIA]: Pizza,
    [BusinessTypes.HOTEL]: Hotel,
    [BusinessTypes.FAST_FOOD]: FastFood,
    [BusinessTypes.COFFEE_SHOP]: CoffeeCup,
};

export const RESTURANT_UI_TEMPLATES: IBusinessUITemplate[] = [
    {
        id: 0,
        name: "Ordinary",
        screenShot: ""
    }
];

export const CAFE_UI_TEMPLATES: IBusinessUITemplate[] = [
    {
        id: 0,
        name: "Ordinary",
        screenShot: ""
    }
];

export const FAST_FOOD_UI_TEMPLATES: IBusinessUITemplate[] = [
    {
        id: 0,
        name: "Ordinary",
        screenShot: ""
    }
];

export const HOTEL_UI_TEMPLATES: IBusinessUITemplate[] = [
    {
        id: 0,
        name: "Ordinary",
        screenShot: ""
    }
];

export const PIZZERIA_TEMPLATES: IBusinessUITemplate[] = [
    {
        id: 0,
        name: "Ordinary",
        screenShot: ""
    }
];

export const COFE_SHOP_TEMPLATES: IBusinessUITemplate[] = [
    {
        id: 0,
        name: "Ordinary",
        screenShot: ""
    }
];

export const BUSINESS_UI_TEMLATES = {
    [BusinessTypes.RESTAURANT]: RESTURANT_UI_TEMPLATES,
    [BusinessTypes.CAFE]: CAFE_UI_TEMPLATES,
    [BusinessTypes.PIZZERIA]: PIZZERIA_TEMPLATES,
    [BusinessTypes.HOTEL]: HOTEL_UI_TEMPLATES,
    [BusinessTypes.FAST_FOOD]: FAST_FOOD_UI_TEMPLATES,
    [BusinessTypes.COFFEE_SHOP]: COFE_SHOP_TEMPLATES,
};

export const CURRENCY_SYMBOLS = {
    [CurrencyTypes.AMD]: '֏',
    [CurrencyTypes.RUB]: '₽',
    [CurrencyTypes.USD]: '$',
};

  export const fullProfileContact: IProfilecontactItem[] = [
        { id: "phone_numbers", icon: Phone },
        { id: "facebook", icon: Facebook },
        { id: "instagram", icon: Instagram },
        { id: "whatsapp", icon: WhatsApp },
        { id: "telegram", icon: Telegram },
        { id: "viber", icon: Viber },
    ];

